import React from 'react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import styles from './style.scss';

const ToolBar = ({components, translations, roles, onNewRoleClick}) =>
    <div
        className={styles.tableToolbarWrapper}
    >
        <div
            className={styles.tableToolbar}
        >
            <span
                className={styles.totalWrapper}
            >
                {`${translations.roles} (${roles.length})`}
            </span>
            <div
                className={styles.rolesButtonsWrapper}
            >
                <Button
                    text={translations.newRole}
                    style={{height: '26px', lineHeight: '26px'}}
                    onClick={onNewRoleClick}
                />
                {components.searchField}
            </div>
        </div>
    </div>;

export {
    ToolBar
};